export const otaTypes = [{ label: 'HFX Flash', value: 'hfx_flash' }]; // customer OTA types. laid out like select options
